import { WEEKS, GENDER, AGE, GRANULARITY, GRANULARITY_UNIT } from "@/commons/enums";

/**
 * 指定した日付の曜日を返す
 * @param date 日付
 * @returns 指定した日付の曜日
 */
export function getDayOfWeekString(date: string): string {
  const dayOfWeek = new Date(date).getDay();
  switch (dayOfWeek) {
    case WEEKS.SUNDAY.value:
      return WEEKS.SUNDAY.text;
    case WEEKS.MONDAY.value:
      return WEEKS.MONDAY.text;
    case WEEKS.TUESDAY.value:
      return WEEKS.TUESDAY.text;
    case WEEKS.WEDNESDAY.value:
      return WEEKS.WEDNESDAY.text;
    case WEEKS.THURSDAY.value:
      return WEEKS.THURSDAY.text;
    case WEEKS.FRIDAY.value:
      return WEEKS.FRIDAY.text;
    case WEEKS.SATURDAY.value:
      return WEEKS.SATURDAY.text;
    default:
      return "";
  }
}

export function getGenderLabelByValue(value: number): string {
  switch (value) {
    case GENDER.MALE.value:
      return GENDER.MALE.text;
    case GENDER.FEMALE.value:
      return GENDER.FEMALE.text;
    default:
      return "";
  }
}

export function getAgeLabelByValue(value: number): string {
  switch (value) {
    case AGE.TEEN.value:
      return AGE.TEEN.text;
    case AGE.TWENTIES.value:
      return AGE.TWENTIES.text;
    case AGE.THIRTIES.value:
      return AGE.THIRTIES.text;
    case AGE.FORTIES.value:
      return AGE.FORTIES.text;
    case AGE.FIFTIES.value:
      return AGE.FIFTIES.text;
    case AGE.SIXTIES.value:
      return AGE.SIXTIES.text;
    default:
      return "";
  }
}

/**
 * URLクエリの表示単位から表示粒度を返す
 * @param value URLクエリの表示単位
 * @param fallback 表に無い値だったときに返す表示粒度
 * @returns 表示粒度
 */
export function getGranularityByRouterQueryUnit<
  T extends (typeof GRANULARITY)[keyof typeof GRANULARITY]
>(
  value: string | (string | null)[],
  fallback: T
): T | keyof typeof GRANULARITY_UNIT {
  if (typeof value !== "string") return fallback;
  const found = Object.entries(GRANULARITY_UNIT).find(([, unit]) => unit === value);
  return found ? (Number(found[0]) as keyof typeof GRANULARITY_UNIT) : fallback;
}

/**
 * 絞り込んだエリアから表示粒度を返す
 * @param cityIds 絞り込んだ市区町村IDs
 * @param townIds 絞り込んだ町域IDs
 * @returns 表示粒度
 */
export function getGranularityByFilterArea(
  cityIds?: string[],
  townIds?: string[]
): typeof GRANULARITY.CITY | typeof GRANULARITY.TOWN | typeof GRANULARITY.STREET {
  if (townIds && townIds.length > 0) return GRANULARITY.STREET;
  if (cityIds && cityIds.length > 0) return GRANULARITY.TOWN;
  return GRANULARITY.CITY;
}
